import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=586fb863&"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordConfirm.vue?vue&type=style&index=0&id=586fb863&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports